import { supabase } from './client';

export interface OrderDispatchAssignment {
  id: string;
  order_id: string;
  courier_id: string;
  status: string;
  assigned_at: string;
  released_at?: string | null;
  completed_at?: string | null;
  cancelled_at?: string | null;
  notes?: string | null;
}

export const assignOrderToCourier = async (orderId: string, courierId: string) => {
  // Assign a changa to a courier (biker)
  const { data, error } = await supabase
    .from('order_dispatch_assignments')
    .insert({ order_id: orderId, courier_id: courierId, status: 'assigned' })
    .select()
    .single();
  if (error) throw error;
  return data as OrderDispatchAssignment;
};

export const releaseOrderAssignment = async (assignmentId: string) => {
  // Update the active assignment to released status
  const { data, error } = await supabase
    .from('order_dispatch_assignments')
    .update({ status: 'released', released_at: new Date().toISOString() })
    .eq('id', assignmentId)
    .eq('status', 'assigned') // Solo si está actualmente assigned
    .select()
    .single();
  if (error) throw error;
  return data as OrderDispatchAssignment;
};

export const completeOrderAssignment = async (assignmentId: string) => {
  // Mark assignment as completed
  const { data, error } = await supabase
    .from('order_dispatch_assignments')
    .update({ status: 'completed', completed_at: new Date().toISOString() })
    .eq('id', assignmentId)
    .eq('status', 'assigned')
    .select()
    .single();
  if (error) throw error;
  return data as OrderDispatchAssignment;
};

export const getAssignmentsByOrderId = async (orderId: string) => {
  // Get all assignments for an order
  const { data, error } = await supabase
    .from('order_dispatch_assignments')
    .select('*')
    .eq('order_id', orderId)
    .order('assigned_at', { ascending: false });
  if (error) throw error;
  return data as OrderDispatchAssignment[];
};

export const getActiveAssignmentForOrder = async (orderId: string) => {
  // Get the current active assignment for an order
  const { data, error } = await supabase
    .from('order_dispatch_assignments')
    .select('*')
    .eq('order_id', orderId)
    .eq('status', 'assigned')
    .maybeSingle();
  if (error) throw error;
  return data as OrderDispatchAssignment | null;
};
